module.exports = __webpack_public_path__ + "img/郑州市.36e47539.png";